export default "__VITE_ASSET__Cyd6G2pe__"